module.exports = __webpack_public_path__ + "img/img_2.9e527c3d.png";